// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_20-1";
export var movingGradient = "_20-4";
export var movingGradientBlock = "_20-2";
export var skeleton = "_20-0";
export var skeletonText = "_20-3";